import { render } from "./ProgramCreateConfirmation.vue?vue&type=template&id=19d28f4e"
import script from "./ProgramCreateConfirmation.vue?vue&type=script&lang=js"
export * from "./ProgramCreateConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__